import React from 'react'
import { useDroppable } from '@dnd-kit/core'

type DroppableAreaProps = {
  id: string
  enabled: boolean
  className?: string
  isEmpty?: boolean
  emptyLabel?: string
  children: React.ReactNode
}

const DroppableArea: React.FC<DroppableAreaProps> = ({
  id,
  enabled,
  className,
  isEmpty,
  emptyLabel = 'Drop a career here',
  children,
}) => {
  const { setNodeRef, isOver } = useDroppable({ id, disabled: !enabled })
  const showEmptyHint = enabled && isEmpty
  return (
    <div
      ref={setNodeRef}
      className={`${className || ''} relative transition-colors duration-150 ${
        enabled
          ? isOver
            ? 'bg-[#EAF4EF] ring-2 ring-green/40 rounded-md'
            : 'bg-[#FAFAFA] rounded-md'
          : ''
      }`}
    >
      {children}
      {showEmptyHint && (
        <div
          className={`pointer-events-none absolute inset-0 flex items-center justify-center rounded-md border-2 border-dashed ${
            isOver ? 'border-green text-green' : 'border-[#D8D8D8] text-gray-medium'
          }`}
        >
          <span className="font-sans text-sm font-semibold">{emptyLabel}</span>
        </div>
      )}
    </div>
  )
}

export default DroppableArea
